export default "__VITE_ASSET__$nXI9I26__"